<template>
    <div class="row" style="margin: 0;">
        <div class="col-12" style="padding: 0; padding-left: 15px; padding-right: 15px;">
            <table class="table_costs">
                <thead>
                    <tr>
                        <th style="vertical-align: middle; padding:2px 0;">
                            <button @click="openPDF(calculator_data.id)"
                                class="btn btn-info btn-xs">Preview PDF</button>
                        </th>
                        <th style="text-align: center;">Qt</th>
                        <th style="text-align: center;">Costs</th>
                        <th style="text-align: center;">Parcial</th>
                    </tr>
                </thead>
                <tbody v-if="categories.length == 0">
                    <tr class="no_record">
                        <th colspan="5" class="text-center">
                            <h4 class="nameTable">No record</h4>
                        </th>
                    </tr>
                </tbody>
                <template v-else>
                    <tbody v-for="(category, idx) in categories" :id="'body_' + category.name.toLowerCase()" :key="idx">
                        <tr class="title_table">
                            <th colspan="3">
                                <button class="btn btn-primary btn-xs btn-add-item_cat" @click="addItem(idx)">
                                    Add Item
                                </button>
                                <input type="text" class="nameTable" v-model="category.name"
                                    @input="handleInput(editCategory, category)" @click="selectInputAllValue"
                                    @mousedown.prevent>
                            </th>
                            <th class="total_parcial">
                                ${{ formatMoney(totalCategory(category.items)) }}
                                <button class="btn-event btn-delete" @click="removeCategory(category.id, idx)">
                                    <i class="fas fa-times"></i>
                                </button>
                            </th>
                        </tr>
                        <tr v-for="(item, index) in category.items" :key="category.id + '-' + item.id + '-' + index"
                            :id="'tr-' + item.id" v-bind:class="[(item.id == selected) ? 'active' : '']">
                            <td class="orden_name" @click="btnActiveTR(item.id, idx)">
                                <button class="btn-event btn-action inactivo">
                                    <i class="fas fa-cog"></i>
                                </button>
                                <input type="text" class="name_orden" v-model="item.name"
                                    @input="handleInput(editItem, item)" @click="selectInputAllValue"
                                    @mousedown.prevent />
                            </td>
                            <td class="qty" style="text-align: center;" @click="btnActiveTR(item.id, idx)">
                                <QtyInput class_input="qty" v-model="item.qty" @save="handleInput(editItem, item)" />
                                <!-- <input type="text" class="qty" v-model.number="item.qty" @input="handleInput(editItem, item)" @click="selectInputAllValue" @mousedown.prevent/> -->
                            </td>
                            <td class="costs" style="text-align: right;" @click="btnActiveTR(item.id, idx)">
                                <AmountInput class_input="cost" v-model="item.cost" :subtotal="99999999"
                                    modo_calc="amount" @save="handleInput(editItem, item)" />
                                <!-- <input type="text" class="cost" v-model.number="item.cost" @input="handleInput(editItem, item)" @click="selectInputAllValue" @mousedown.prevent/> -->
                            </td>
                            <td class="parcial" style="text-align: right;" @click="btnActiveTR(item.id, idx)">
                                ${{ formatMoney(itemAmount(item)) }}
                                <button class="btn-event btn-delete" @click="removeItem(item, idx, index)"
                                    v-if="category.items.length > 1">
                                    <i class="fas fa-times"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </table>
        </div>
        <div class="col-4" style="padding-top: 20px;">
            <button class="btn btn-success btn-sm" @click="addCategory">Add Category >> </button>
        </div>
        <div class="col-8" style="padding-top: 20px;">
            <table class="business_expenses">
                <thead>
                    <tr>
                        <th class="subtotal" style="">Sub Total</th>
                        <th class="subtotal"
                            style="width: 150px;min-width: 150px;max-width: 150px;">
                            {{ formatMoney(grandTotal) }}
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="col-12">
            <table class="business_expenses">
                <thead>
                    <tr>
                        <th style="font-weight:bold;">Business Expenses</th>
                        <th style="text-align:center;color:#5ac146;">%</th>
                        <th style="text-align: center;color: #031099;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(expense, idx) in expenses" :key="idx">
                        <td>
                            <input type="text" class="expenses" v-model="expense.name"
                                @input="handleInput(editExpense, expense)" @click="selectInputAllValue"
                                @mousedown.prevent />
                        </td>
                        <td>
                            <PercentInput v-model="expense.percent" class_input="expenses" @save="editExpense(expense)"
                                style="text-align: right;" />
                            <!-- <input type="text" class="expenses" style="text-align: right;"
                            :value="expense.percent"
                            @input="validatePercent($event, idx)"
                            @blur="formatPercent(idx)"
                            @click="selectInputAllValue" @mousedown.prevent
                            /> -->
                        </td>
                        <td>
                            ${{ formatMoney(expenseAmount(expense)) }}
                            <button class="btn-event btn-delete" @click="removeExpense(expense, idx)">
                                <i class="fas fa-times"></i>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <button class="btn btn-success btn-xs" @click="addExpense">Add >> </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12">
            <table class="business_expenses">
                <tfoot>
                    <tr>
                        <td style="width: 246px;color: #031099;">Total</td>
                        <td>{{ formatMoney(totalExpenses) }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div class="col-12">
            <table class="external_expenses">
                <thead>
                    <tr>
                        <th style="font-weight:bold;">External Expenses</th>
                        <th style="text-align:center;color:#5ac146;">% - $</th>
                        <th style="text-align:center;"></th>
                        <th style="text-align: center;color: #031099;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(external, idx) in externalExps" :key="idx">
                        <td class="name_external">
                            <input type="text" class="expenses" v-model="external.name" @click="selectInputAllValue"
                                @mousedown.prevent />
                        </td>
                        <td class="mode_calc">
                            <div class="onoffswitch external">
                                <input type="checkbox" class="onoffswitch-checkbox" :id="'modeCacl' + idx"
                                    :checked="external.mode_calc === 'percent'"
                                    @change="onModeCalcChange($event, external)" />
                                <label class="onoffswitch-label" :for="'modeCacl' + idx">
                                    <span class="onoffswitch-inner"></span>
                                    <span class="onoffswitch-switch"></span>
                                </label>
                            </div>
                        </td>
                        <td :colspan="external.mode_calc === 'percent' ? 1 : 2"
                            :class="external.mode_calc === 'amount' ? 'td_amount' : 'td_percent'">
                            <PercentInput v-if="external.mode_calc === 'percent'" class_input="expenses"
                                v-model="external.percent" :modo_calc="external.mode_calc"
                                @input="external.amount = ((external.percent || 0) / 100) * totalExpenses"
                                @save="editExternalExps(external)" style="text-align: right;" />
                            <AmountInput v-else class_input="expenses" v-model="external.amount"
                                :modo_calc="external.mode_calc"
                                @input="external.percent = ((external.amount || 0) / totalExpenses) * 100"
                                @save="editExternalExps(external)" style="text-align: right;" />
                            <button class="btn-event btn-delete" v-if="external.mode_calc != 'percent'"
                                @click="removeExternalExps(external, idx)">
                                <i class="fas fa-times"></i>
                            </button>
                        </td>
                        <td v-if="external.mode_calc === 'percent'" class="td_parcial">
                            ${{ formatMoney(external.amount) }}
                            <button class="btn-event btn-delete" @click="removeExternalExps(external, idx)">
                                <i class="fas fa-times"></i>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4">
                            <button class="btn btn-success btn-xs" @click="addExternalExps">Add >> </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import QtyInput from './inputs/QtyInput.vue';
import AmountInput from './inputs/AmountInput.vue';
import PercentInput from './inputs/PercentInput.vue';
export default {
    components: {
        QtyInput,
        AmountInput,
        PercentInput
    },
    props: {
        propData: {
            type: Object,
            required: false,
            default: () => ({})
        },
        fwv: { type: String, default: "estimate" },
    },
    data() {
        return {
            // Add any data properties needed for the calculator costs
            isLoading: false,
            calculator_data: null,
            categories: [],
            expenses: [],
            externalExps: [],
            selected: 0,
            itemSelected: { id: 0 },
            timeoutId: null,
            showModalPrint: false,
            // @ts-ignore
            user_id: window.master_client,
            // @ts-ignore
            org_id: window.localorgdata,
            addNew: null,
        };
    },
    mounted() {
        // Logic to initialize the calculator costs component
        this.calculator_data = this.propData;
        console.log('mounted calculator_data', this.calculator_data)
        if (this.calculator_data) {
            this.categories = this.calculator_data.categories_with_items || [];
            this.expenses = this.calculator_data.expenses || [];
            this.externalExps = this.calculator_data.external_exps || [];
        }
        this.addNew = {
            user_id: this.user_id,
            org_id: this.org_id,
        };
        if(this.fwv === 'estimate') {this.addNew.calc_estimate_id= this.calculator_data.id}
        if(this.fwv === 'invoice') {this.addNew.calc_invoice_id= this.calculator_data.id}
        setTimeout(() => {
            // mostrar opciones de pdf
            this.showModalPrint = true;
            // this.applyInitialFormat();
        }, 500);
    },
    methods: {
        /**
         * Maneja el debounce de cualquier método.
         * @param {Function} callback - Método a ejecutar.
         * @param {*} value - Valor que se pasa al callback (ej: v-model).
         * @param {Number} delay - Tiempo en ms para esperar antes de ejecutar.
         */
        handleInput(callback, value, delay = 600) {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
                if (typeof callback === 'function') {
                    if (value == '' && value == null) return;
                    callback(value); // Ejecuta la función pasada como argumento
                }
            }, delay);
        },
        // Define methods for handling calculator costs logic
        formatMoney(value) {
            if (typeof value !== 'number') {
                value = parseFloat(value) || 0;
            }
            return value.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        totalCategory(items) {
            if (!items || items.length === 0) return 0;
            let total = items.reduce((sum, item) => sum + this.itemAmount(item), 0);
            // console.log('totalCategory', total)
            return total;
        },
        addCategory() {
            let getUrl = 'calcestimate/categories/add';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/categories/add';
            // @ts-ignore
            window.billing.post(getUrl, this.addNew).then((response) => {
                console.log('category add:', response.data);
                this.categories.push(response.data);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching category add:', error);
            });
        },
        editCategory(category) {
            let getUrl = 'calcestimate/categories/edit';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/categories/edit';
            // @ts-ignore
            window.billing.post(getUrl, {
                user_id: this.user_id,
                org_id: this.org_id,
                id: category.id,
                name: category.name,
            }).then((response) => {
                console.log('category edit:', response.data);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching category edit:', error);
            });
        },
        removeCategory(category_id, catIndex) {
            if (this.categories[catIndex].items.length > 0) {
                this.$swal({
                    title: "Delete this Category?",
                    text: "Are you sure you want to delete the category? Your items will be lost. Do you want to continue? Are you sure?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes, Delete it!",
                }).then((result) => {
                    if (result.value) {
                        this.deleteCategory(category_id, catIndex);
                    }
                });
            } else {
                this.deleteCategory(category_id, catIndex);
            }
        },
        deleteCategory(category_id, catIndex) {
            let getUrl = 'calcestimate/categories/delete';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/categories/delete';
            // @ts-ignore
            window.billing.post(getUrl, {
                user_id: this.user_id,
                org_id: this.org_id,
                category_id: category_id,
            }).then((response) => {
                console.log('category delete:', response.data);
                this.categories.splice(catIndex, 1);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching category delete:', error);
            });
        },
        addItem(catIndex) {
            let getUrl = 'calcestimate/items/add';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/items/add';
            // @ts-ignore
            window.billing.post(getUrl, {
                user_id: this.user_id,
                org_id: this.org_id,
                category_id: this.categories[catIndex].id,
            }).then((response) => {
                console.log('article add:', response.data);
                this.categories[catIndex].items.push(response.data);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching article add:', error);
            });
        },
        editItem(item) {
            let getUrl = 'calcestimate/items/edit';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/items/edit';
            // @ts-ignore
            window.billing.post(getUrl, {
                user_id: this.user_id,
                org_id: this.org_id,
                id: item.id,
                name: item.name,
                qty: item.qty,
                cost: item.cost,
                amount: item.amount,
            }).then((response) => {
                console.log('article edit:', response.data);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching article edit:', error);
            });
        },
        removeItem(item, catIndex, itemIndex) {
            this.categories[catIndex].items.splice(itemIndex, 1);
            let getUrl = 'calcestimate/items/delete';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/items/delete';
            // @ts-ignore
            window.billing.post(getUrl, {
                user_id: this.user_id,
                org_id: this.org_id,
                id: item.id,
            }).then((response) => {
                console.log('article delete:', response.data);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching article delete:', error);
            });
        },
        itemAmount(item) {
            let qty = parseFloat(item.qty) || 0;
            let cost = parseFloat(item.cost) || 0;
            let amount = qty * cost;
            if (cost < 0) {
                amount = -Math.abs(amount);
            }
            // console.log('itemAmount', item.id, amount);
            item.amount = amount;
            return amount;
        },
        expenseAmount(expense) {
            const percent = parseFloat(expense.percent) || 0;
            return (this.grandTotal * percent) / 100;
        },
        addExpense() {
            let getUrl = 'calcestimate/expenses/add';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/expenses/add';
            // @ts-ignore
            window.billing.post(getUrl, this.addNew).then((response) => {
                console.log('expenses add:', response.data);
                this.expenses.push(response.data);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching expenses add:', error);
            });
        },
        editExpense(expense) {
            let getUrl = 'calcestimate/expenses/edit';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/expenses/edit';
            // @ts-ignore
            window.billing.post(getUrl, {
                user_id: this.user_id,
                org_id: this.org_id,
                id: expense.id,
                name: expense.name,
                percent: expense.percent,
            }).then((response) => {
                console.log('expenses edit:', response.data);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching expenses edit:', error);
            });
        },
        removeExpense(expense, index) {
            this.expenses.splice(index, 1);
            let getUrl = 'calcestimate/expenses/delete';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/expenses/delete';
            // @ts-ignore
            window.billing.post(getUrl, {
                user_id: this.user_id,
                org_id: this.org_id,
                id: expense.id,
            }).then((response) => {
                console.log('expenses delete:', response.data);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching expenses delete:', error);
            });
        },
        btnActiveTR(id, cat_idx) {
            let t = this;
            let s = t.selected;
            let list = t.categories[cat_idx].items;
            let item = list.find(item => item.id === id);
            if (item == null || item.length == 0) return;
            if (t.selected != id) {
                t.selected = id;
                t.itemSelected = item;
                list.forEach(item => {
                    let elem = document.querySelector('#tr-' + id);
                    elem.classList.remove('active');
                });
            }
            let elem = document.querySelector('#tr-' + id);
            elem.classList.add('active');
        },
        openPDF(id) {
            // @ts-ignore
            let oauth_m = window.oauth_m;
            // @ts-ignore
            let urlbase = window.urlbase;
            if(this.fwv === 'estimate'){
                window.open(urlbase + "pdf/estimate-calculator/" + oauth_m + "/" + id, "_blank");
            }else{
                window.open(urlbase + "pdf/invoice-calculator/" + oauth_m + "/" + id, "_blank");
            }
        },
        selectInputAllValue(event) {
            setTimeout(() => {
                event.target.select();
            }, 0);
        },
        onModeCalcChange(event, item) {
            item.mode_calc = event.target.checked ? "percent" : "amount";
            this.editExternalExps(item);
        },
        addExternalExps() {
            let getUrl = 'calcestimate/externalExps/add';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/externalExps/add';
            // @ts-ignore
            window.billing.post(getUrl, this.addNew).then((response) => {
                console.log('external add:', response.data);
                this.externalExps.push(response.data);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching external add:', error);
            });
        },
        editExternalExps(external) {
            let getUrl = 'calcestimate/externalExps/edit';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/externalExps/edit';
            // @ts-ignore
            window.billing.post(getUrl, {
                user_id: this.user_id,
                org_id: this.org_id,
                id: external.id,
                name: external.name,
                mode_calc: external.mode_calc,
                percent: external.percent,
                amount: external.amount,
            }).then((response) => {
                console.log('external edit:', response.data);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching external edit:', error);
            });
        },
        removeExternalExps(external, index) {
            this.externalExps.splice(index, 1);
            let getUrl = 'calcestimate/externalExps/delete';
            if(this.fwv === 'invoice') getUrl = 'calcinvoice/externalExps/delete';
            // @ts-ignore
            window.billing.post(getUrl, {
                user_id: this.user_id,
                org_id: this.org_id,
                id: external.id,
            }).then((response) => {
                console.log('external delete:', response.data);
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.error('Error fetching external delete:', error);
            });
        },
        updateExternalValues(totalGeneral) {
            this.externalExps.forEach(external => {
                if (external.mode_calc === 'percent') {
                    external.amount = ((external.percent || 0) / 100) * totalGeneral;
                } else {
                    external.percent = ((external.amount || 0) / totalGeneral) * 100;
                }
            });
        },
    },
    watch: {
        propData: function (newVal) {
            this.calculator_data = newVal;
            // console.log('watch template', this.template)
        }
    },
    computed: {
        grandTotal() {
            let subTotal = this.categories.reduce((sum, cat) => sum + this.totalCategory(cat.items), 0);
            return subTotal;
        },
        totalExpenses() {
            const expensesTotal = this.expenses.reduce((sum, exp) => sum + this.expenseAmount(exp), 0);
            let totalGeneral = this.grandTotal + expensesTotal;
            this.updateExternalValues(totalGeneral);
            return totalGeneral;
        }
    },
}
</script>
<style lang="scss" scoped>
@import url('./tableCost.scss');
</style>
